<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('common.process') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('energyMonitor.process.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('energyMonitor.process.text')}}
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="center" class="max-width-1000 mx-auto">
      <!-- <v-col cols="12">
        <v-row>
          <v-card
            v-for="(item,index) in process"
            :key="index"
            class="my-2 pl-4 w-100"
            :color="item.color">
            <v-row class="align-center">
              <v-col
                class="white--text display-3 text-center width-100">
                {{ index + 1}}
              </v-col>
              <v-col
                class="white--text title"
                style="width:504px">
                  {{ $t(item.text) }}
              </v-col>
              <v-col
                class="py-0 width-180">
                  <v-img
                    height="150px"
                    width="200px"
                    :src="item.img"
                    cover>
                  </v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-row>
      </v-col> -->
      <v-col
        v-for="(item,index) in process"
        :key="index"
        cols="12" sm="6" md="3"
        class="pb-8">
        <v-row>
          <v-col class="text-center timeline-bottom border">
            <span class="dot" :style="'background-color:' + item.color + ';'">{{ index+1 }}</span>
            <!-- <v-img
              height="150px"
              width="200px"
              :src="item.img"
              cover>
            </v-img> -->
            <v-icon class="icon">
              {{ item.icon }}
            </v-icon>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-8">
            {{ $t(item.text) }}
          </v-col>
        </v-row>
        <!-- <span class="dot" :style="'background-color:' + item.color + ';'">{{ index+1 }}</span> -->
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'EnergyMonitorProcess',
    extends: DataComponentBase,

    data: () => ({
      process: [
        {
          title: "mdi-numeric-1",
          class: "text-left",
          text: "energyMonitor.process.step.01.text",
          color: "#4CAF50",
          icon: "mdi-pencil-ruler",
        },
        {
          title: "mdi-numeric-2",
          class: "text-right",
          text: "energyMonitor.process.step.02.text",
          color: "#3F51B5",
          icon: "mdi-gauge",
        },
        {
          title: "mdi-numeric-3",
          class: "text-left",
          text: "energyMonitor.process.step.03.text",
          color: "#009688",
          icon: "mdi-ballot-recount-outline",
        },
        {
          title: "mdi-numeric-4",
          class: "text-right",
          text: "energyMonitor.process.step.04.text",
          color: "#2196F3",
          icon: "mdi-monitor-cellphone",
        },
      ],

    }),

    methods: {

    },
  }
</script>
